import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListComponent } from './product-list/product-list.component';
import { AddProductComponent } from './add-product/add-product.component';
import { AddOrderComponent } from './add-order/add-order.component';
import { AddClientComponent } from './add-client/add-client.component';
import { OrderListComponent } from './order-list/order-list.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { AddCashLoanComponent } from './add-cash-loan/add-cash-loan.component';
import { LoanListComponent } from './loan-list/loan-list.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { AdminApprovalsComponent } from './admin-approvals/admin-approvals.component';
import { CashDiscrepancyComponent } from './cash-discrepancy/cash-discrepancy.component';
import { StockDiscrepancyComponent } from './stock-discrepancy/stock-discrepancy.component';
import { FinancialDashboardComponent } from './financial-dashboard/financial-dashboard.component';
import { DiscrepancyDashboardComponent } from './discrepancy-dashboard/discrepancy-dashboard.component';
import { AdminCategoriesComponent } from './admin-categories/admin-categories.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthGuard } from './guards/auth.guard';
import { CashHistoryComponent } from './cash-history/cash-history.component';
import { CashReconciliationComponent } from './cash-reconciliation/cash-reconciliation.component';
import { AvoirListComponent } from './avoir-list/avoir-list.component';
import { AvoirDetailComponent } from './avoir-detail/avoir-detail.component';
import { ReconciliationWorkbenchComponent } from './reconciliation-workbench/reconciliation-workbench.component';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verify-email', component: EmailVerificationComponent },
  { path: 'home', component: ProductListComponent, canActivate: [AuthGuard] },
  { path: 'productList', component: ProductListComponent, canActivate: [AuthGuard] },
  { path: 'addProduct', component: AddProductComponent, canActivate: [AuthGuard] },
  { path: 'addOrder', component: AddOrderComponent, canActivate: [AuthGuard] },
  { path: 'addClient', component: AddClientComponent, canActivate: [AuthGuard] },
  { path: 'orderList', component: OrderListComponent, canActivate: [AuthGuard] },
  { path: 'orderDetails', component: OrderDetailsComponent, canActivate: [AuthGuard] },
  { path: 'updateOrder', component: AddOrderComponent, canActivate: [AuthGuard] },
  { path: 'updateProduct', component: AddProductComponent, canActivate: [AuthGuard] },
  { path: 'addCashLoan', component: AddCashLoanComponent, canActivate: [AuthGuard] },
  { path: 'loanList', component: LoanListComponent, canActivate: [AuthGuard] },
  { path: 'updateLoan', component: AddCashLoanComponent, canActivate: [AuthGuard] },
  { path: 'clientDetails', component: ClientDetailsComponent, canActivate: [AuthGuard] },
  { path: 'admin-approvals', component: AdminApprovalsComponent, canActivate: [AuthGuard] },
  { path: 'cash-discrepancies', component: CashDiscrepancyComponent, canActivate: [AuthGuard] },
  { path: 'stock-discrepancies', component: StockDiscrepancyComponent, canActivate: [AuthGuard] },
  { path: 'financial-dashboard', component: FinancialDashboardComponent, canActivate: [AuthGuard] },
  { path: 'discrepancy-dashboard', component: DiscrepancyDashboardComponent, canActivate: [AuthGuard] },
  { path: 'admin-categories', component: AdminCategoriesComponent, canActivate: [AuthGuard] },
  { path: 'cash-history', component: CashHistoryComponent, canActivate: [AuthGuard] },
  { path: 'reconciliation', component: CashReconciliationComponent, canActivate: [AuthGuard] },
  { path: 'avoir-list', component: AvoirListComponent, canActivate: [AuthGuard] },
  { path: 'avoir-detail/:id', component: AvoirDetailComponent, canActivate: [AuthGuard] },
  { path: 'reconciliation-workbench', component: ReconciliationWorkbenchComponent, canActivate: [AuthGuard] }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
